import { getActivityId, getPinDomain, getPinSnippet } from './autoLayout';
import {
  formatContextChipLabel,
  selectionItemFromShape,
  truncateContextLabel,
} from './selectionItemFromShape.js';

export {
  formatContextChipLabel,
  selectionItemFromShape,
  truncateContextLabel,
};

export function getActivityTitle(activity) {
  if (!activity) return '';
  const url = activity?.content?.[0]?.urls?.[0];
  return String(
    url?.title ||
    activity?.content?.[0]?.text ||
    getPinSnippet(activity) ||
    getPinDomain(activity) ||
    ''
  ).trim();
}

function buildActivityLabelMap(activities = []) {
  const map = new Map();
  for (const activity of activities) {
    const id = getActivityId(activity);
    if (!id) continue;
    const title = getActivityTitle(activity) || id.slice(-6);
    map.set(id, formatContextChipLabel('user-pin', title));
  }
  return map;
}

export function collectBoardSelectionItems(editor, { activities = [] } = {}) {
  if (!editor) return [];

  const pinLabelById = buildActivityLabelMap(activities);
  const items = [];

  for (const shapeId of editor.getSelectedShapeIds()) {
    const shape = editor.getShape(shapeId);
    const item = selectionItemFromShape(shape, { activities, pinLabelById });
    if (item) items.push(item);
  }

  return items;
}

export function selectionItemsToContext(selectionItems) {
  const pinIds = selectionItems
    .filter(item => item.kind === 'user-pin')
    .map(item => item.id);
  const shapeIds = selectionItems
    .filter(item => item.kind === 'shape' || item.kind === 'ai-pin')
    .map(item => item.id);
  return { pinIds, shapeIds };
}

export function buildPinLabelById(activities = []) {
  return buildActivityLabelMap(activities);
}
